import { Model } from '@models/core/base.model';
import { Employee } from '@models/employee/employee.model';

export class BenefitsDigest extends Model {
    static _resource = 'benefits/digest';

    static _version = 'v2';

    get relatedTable(): string {
        return this._attributes['relatedTable'];
    }

    get relatedColumn(): string {
        return this._attributes['relatedColumn'];
    }

    get prevValue(): string | number {
        return this._attributes['prevValue'];
    }

    get newValue(): string | number {
        return this._attributes['newValue'];
    }

    get createdAt(): string {
        return this._attributes['createdAt'];
    }

    /**
     * The foreign key in HR is `user_id`, that's why this relationship is called `user`. At some point we should rename it to `employee`.
     */
    get user(): Employee {
        return this.hasOne(Employee, 'user');
    }
}
